<template>
  <div class="summary_list">
    <draggable v-model="items" handle=".handle">
      <div class="list_entry" v-for="index in items.length" :key="index">
        <p class="prompt" v-if="items[index-1].prompt.length > 0" v-html="items[index-1].prompt" />
        <aside class="handle">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            viewBox="0 0 72 72"
            width="32px"
            height="32px"
            xml:space="preserve"
          >
            <path
              class="st0"
              d="M24.6 32.5c1 0 2-.4 2.7-1.1l8.6-8.6 8.6 8.6c.7.7 1.6 1 2.7 1s2-.4 2.7-1c1.5-1.5 1.5-3.9 0-5.4L38.6 14.8c-1.5-1.5-3.9-1.5-5.4 0L21.9 26.1c-1.5 1.5-1.5 3.9 0 5.4.8.7 1.7 1 2.7 1zM50.1 40.6c-1.4-1.4-3.9-1.4-5.4 0l-8.6 8.6-8.6-8.6c-1.4-1.4-3.9-1.4-5.4 0-.7.7-1.1 1.7-1.1 2.7 0 1 .4 2 1.1 2.7l11.2 11.3c.7.7 1.6 1 2.7 1 1 0 1.9-.3 2.7-.9L50.1 46c.7-.7 1.1-1.7 1.1-2.7 0-1-.4-2-1.1-2.7z"
            />
            <g id="circle">
              <path
                class="st0"
                d="M36 2.1C17.3 2.1 2.1 17.3 2.1 36S17.3 69.9 36 69.9 69.9 54.7 69.9 36 54.7 2.1 36 2.1zm0 62.4C20.3 64.5 7.5 51.7 7.5 36S20.3 7.5 36 7.5 64.5 20.3 64.5 36 51.7 64.5 36 64.5z"
              />
            </g>
          </svg>
          <p>Move</p>
        </aside>
        <textarea v-if="!locked" v-model="items[index-1].question" placeholder="Type here"></textarea>
        <p v-if="locked" v-html="items[index-1].question"></p>
        <button class="remove" v-if="removable" @click="remove(index-1)">Remove</button>
      </div>
    </draggable>

    <button class="secondary" @click="add()">Add More</button>
  </div>
</template>

<style>
.st0 {
  fill: #77787b;
}
aside {
  margin-right: 1rem;
  text-align: center;
}
.sortable-chosen .st0 {
  fill: green;
}
</style>

<script>
import { mapMutations } from "vuex";
import draggable from "vuedraggable";

export default {
  name: "SummaryField",
  props: {
    valueKey: String,
    initial: Array,
    removable: Boolean,
    locked: Boolean
  },
  data() {
    return {
      items: this.initial || []
    };
  },

  watch: {
    items: {
      handler: function(val) {
        this.setSummaryResponse({ key: this.valueKey, value: val });
      },
      deep: true
    }
  },

  computed: {},

  methods: {
    ...mapMutations(["setSummaryResponse"]),

    remove(index) {
      var beginning = this.items.slice(0, index);
      var end = this.items.slice(index + 1);
      this.items = beginning.concat(end);
    },

    add() {
      this.items.push({ prompt: "", question: "" });
    }
  },

  components: {
    draggable
  }
};
</script>